import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  createProgramWrapper: {},
  collectionWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  createProgramBottom: {
    marginTop: 8,
  },
  selectorWithContent: {
    '& .MuiOutlinedInput-root': {
      minHeight: '48px',
    },
  },
}));
